var u = navigator.userAgent;
export var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
export var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端